// extracted by mini-css-extract-plugin
export default {"display_priscription_modal_container":"PrescriptionDisplayModal_display_priscription_modal_container__5Qh1M"};